import {
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Select,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { useRef } from "react";

function ViewEditRequirement({
  formData,
  deliverables,
  developers,
  onChange,
  onFileChange,
  onFileRemove,
  type,
}) {
  const inputRef = useRef();
  const screenshots = formData?.screenshots || []; // Fallback to empty array

  return (
    <HStack align={"start"}>
      <VStack spacing={4} flex={1}>
        {/* Title & Status */}
        <HStack w={"full"}>
          <FormControl flex={4}>
            <FormLabel>Title</FormLabel>
            <Input
              bg="white"
              name="title"
              value={formData?.title || ""}
              onChange={onChange}
            />
          </FormControl>

          <FormControl flex={2}>
            <FormLabel>Status</FormLabel>
            <Select
              name="status"
              value={formData?.status || ""}
              onChange={onChange}
              isDisabled={type === "new"} // ✅ disables it if it's new
              opacity={type === "new" ? 0.6 : 1} // ✅ visually greys it
              cursor={type === "new" ? "not-allowed" : "pointer"} // ✅ UX touch
            >
              <option value="Not Started">Not Started</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
            </Select>
          </FormControl>
        </HStack>

        {/* Deliverable, Assigned To, Due Date */}
        <HStack w={"full"}>
          <FormControl>
            <FormLabel>Related Deliverable</FormLabel>
            <Select
              name="deliverableId"
              value={formData?.deliverableId || ""}
              onChange={onChange}
              bg="white"
            >
              <option value="">Select</option>
              {deliverables.map((del) => (
                <option key={del.id} value={del.id}>
                  {del.name}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Assigned To</FormLabel>
            <Select
              name="assignedTo"
              placeholder="Select developer"
              value={formData?.assignedTo || ""}
              onChange={onChange}
              bg="white"
            >
              {developers?.map((dev) => (
                <option key={dev.id} value={dev.name}>
                  {dev.name}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Due Date</FormLabel>
            <Input
              type="date"
              name="dueDate"
              value={formData?.dueDate || ""}
              onChange={onChange}
            />
          </FormControl>
        </HStack>

        {/* Requirement Detail */}
        <FormControl>
          <FormLabel>Requirement Detail</FormLabel>
          <Textarea
            name="detail"
            value={formData?.detail || ""}
            onChange={onChange}
          />
        </FormControl>

        {/* Add Screenshots */}
        <FormControl>
          <FormLabel>Screenshots</FormLabel>

          {/* Hidden Input */}
          <Input
            type="file"
            accept="image/*"
            multiple
            onChange={onFileChange}
            ref={inputRef}
            display="none"
          />

          {/* Custom Button to Trigger Input */}
          <Button
            size="sm"
            colorScheme="blue"
            onClick={() => inputRef.current.click()}
            mb={2}
          >
            Upload Screenshots
          </Button>

          {/* Screenshot Previews */}
          {screenshots.length > 0 && (
            <HStack mt={2} spacing={3} wrap="wrap">
              {screenshots.map((file, index) => (
                <Box key={index} position="relative">
                  <a
                    href={
                      typeof file === "string"
                        ? file
                        : URL.createObjectURL(file)
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={
                        typeof file === "string"
                          ? file
                          : URL.createObjectURL(file)
                      }
                      alt={`Screenshot ${index + 1}`}
                      width="80px"
                      height="80px"
                      style={{
                        borderRadius: "5px",
                        border: "1px solid gray",
                        cursor: "pointer",
                      }}
                    />
                  </a>
                  <Button
                    size="xs"
                    colorScheme="red"
                    position="absolute"
                    top={0}
                    right={0}
                    onClick={() => onFileRemove(index)}
                  >
                    ✖
                  </Button>
                </Box>
              ))}
            </HStack>
          )}
        </FormControl>

        {/* Linked Emails */}
        {/* <FormControl>
          <FormLabel>Linked Emails</FormLabel>
          <Input
            name="linked_email" // Fixed typo: was "dueDate"
            value={formData?.linked_email || ""}
            onChange={onChange}
          />
        </FormControl> */}
      </VStack>
    </HStack>
  );
}

export default ViewEditRequirement;
